import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import s from './ImpersonationBar.css';
import ApplicationContext from '../ApplicationContext';
import getUser from '../../utils/getUser';

function Bar({ email }) {
	useStyles(s);

	return (
		<div className={s.root} role="status">
			<form
				className={s.inner}
				method="post"
				action="/admin/impersonate/stop"
			>
				<span className={s.text}>
					Viewing as <strong className={s.email}>{email}</strong>
				</span>
				<span className={s.dot} aria-hidden="true">
					·
				</span>
				<button className={s.button} type="submit">
					Return to admin
				</button>
			</form>
		</div>
	);
}

Bar.propTypes = {
	email: PropTypes.string,
};

Bar.defaultProps = {
	email: '',
};

/**
 * Плашка над шапкой, пока админ смотрит сайт как другой пользователь
 * (в токене есть impersonatedBy). Кнопка возвращает сессию админа.
 * @see src/routes-custom/admin.js
 *
 * Пользователь берётся так же, как в меню: на сервере — из req.user,
 * в браузере — из куки id_token, поэтому SSR и гидратация совпадают.
 */
export default function ImpersonationBar() {
	const { context } = React.useContext(ApplicationContext);
	const user = getUser(context);

	if (!user || !user.impersonatedBy) {
		return null;
	}

	return <Bar email={user.email} />;
}
